import { DateParam } from 'use-query-params'
import { DatePeriodQueryParam } from './DatePeriodQueryParam'

export const QUERY_FILTER_PARAMS_CONFIG = {
  from: DateParam,
  to: DateParam,
  period: DatePeriodQueryParam
}
